import Layout from 'components/layout/Layout'
import ProducerContactRequest from 'features/producer-contact-request/ProducerContactRequest'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { useTranslation } from 'next-i18next/pages'
import type { SeoProps } from 'components/seo/types'

const ProducerContactRequestPage = () => {
  // i18n
  const { t } = useTranslation('b2b', { keyPrefix: 'request' })

  // Constants
  const SEO: SeoProps = {
    title: t('seoTitle', 'Opwekker infofiche')
  }

  return (
    <Layout seo={SEO}>
      <ProducerContactRequest />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'b2b'], i18nConfig))
    },
    revalidate: 600 // re-generate page when a request comes in, once every 10 minutes
  }
}

export default ProducerContactRequestPage
